import PropTypes from 'prop-types';
import React from 'react';

class Button extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const classes = ['btn', `btn--${this.props.type}`];
		if (this.props.disabled) classes.push('disabled');

		return (
			<div className="btn-ctr">
				<button
					onClick={this.props.callback}
					className={classes.join(' ')}
					title={this.props.title}
					rel={this.props.blank ? 'noopener noreferrer' : ''}
					target={this.props.blank ? '_blank' : '_self'}
				>
					{this.props.title}
				</button>
			</div>
		);
	}
}

export default Button;

Button.propTypes = {
	blank: PropTypes.bool,
	callback: PropTypes.func,
	disabled: PropTypes.bool,
	title: PropTypes.string,
	type: PropTypes.string,
};
